export default {
  namespace: 'transportPriceBudget',

  state: {
    list: [],
    pagination: {
      current: 1,
      pageSize: 10,
      total: 0,
    },
    searchParams: {},
  },

  effects: {
    *fetchList({ payload }, { call, put }) {
      try {
        // 这里应该调用实际的API接口
        // const response = yield call(api.getTransportPriceBudgetList, payload);

        // 模拟数据
        const mockData = {
          list: [
            {
              id: '1',
              startLocation: '北京',
              endLocation: '上海',
              transportType: '公路运输',
              distance: '1200',
              budgetPrice: '1.5',
              actualPrice: '1.4',
              status: 'active',
              createTime: '2024-01-01',
              updateTime: '2024-01-15',
            },
            {
              id: '2',
              startLocation: '广州',
              endLocation: '深圳',
              transportType: '公路运输',
              distance: '120',
              budgetPrice: '2.0',
              actualPrice: '1.9',
              status: 'active',
              createTime: '2024-01-02',
              updateTime: '2024-01-16',
            },
          ],
          total: 2,
        };

        yield put({
          type: 'saveList',
          payload: {
            list: mockData.list,
            pagination: {
              ...payload.pagination,
              total: mockData.total,
            },
          },
        });
      } catch (error) {
        console.error('获取运输单价预算数据失败:', error);
      }
    },

    *add({ payload }, { call, put }) {
      try {
        // const response = yield call(api.addTransportPriceBudget, payload);
        yield put({ type: 'fetchList' });
        return { success: true };
      } catch (error) {
        console.error('添加运输单价预算失败:', error);
        return { success: false, message: error.message };
      }
    },

    *update({ payload }, { call, put }) {
      try {
        // const response = yield call(api.updateTransportPriceBudget, payload);
        yield put({ type: 'fetchList' });
        return { success: true };
      } catch (error) {
        console.error('更新运输单价预算失败:', error);
        return { success: false, message: error.message };
      }
    },

    *delete({ payload }, { call, put }) {
      try {
        // const response = yield call(api.deleteTransportPriceBudget, payload.id);
        yield put({ type: 'fetchList' });
        return { success: true };
      } catch (error) {
        console.error('删除运输单价预算失败:', error);
        return { success: false, message: error.message };
      }
    },
  },

  reducers: {
    saveList(state, { payload }) {
      return {
        ...state,
        list: payload.list,
        pagination: payload.pagination,
      };
    },

    saveSearchParams(state, { payload }) {
      return {
        ...state,
        searchParams: payload,
      };
    },
  },
};
